/** Virtual DOM Node */
export function VNode() {}



// WEBPACK FOOTER //
// ../~/preact/src/vnode.js